import {
  SHOW_NFSEN_CONFIG,
  SYNC_NFSE_CONFIG,
  STORE_NFSEN_CONFIG,
} from './LaundryEletronicInvoiceActions'

const INITIAL_STATE = {
  nfsen_config: {},
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_NFSEN_CONFIG.SUCCESS:
      return {
        ...state,
        nfsen_config: action.payload.data.data,
      }
    case SYNC_NFSE_CONFIG.SUCCESS:
      return {
        ...state,
      }
    case STORE_NFSEN_CONFIG.SUCCESS:
      return {
        ...state,
      }
    default:
      return state
  }
}
